/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Mision_Vision_Informacion = ({imagen, titulo, parrafo}) => {

    const {sCell, masSM, sTab} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            spacing={2}
            size={12}>

            <Grid2 container size={{xs: 12, sm: 6, md: 7}} sx={{pr: masSM ? 14 : 0,}}>

                <Grid2 container size={12}>
                    <Typography
                        sx={{fontSize: 48, fontWeight: 700, width: '100%', textAlign: sCell ? 'center' : 'flex-start'}}>
                        {titulo}
                    </Typography>
                </Grid2>

                <Grid2 container size={12}>
                    <Typography sx={{
                        fontSize: 16,
                        fontWeight: 400,
                        mt: sCell ? 3 : 0,
                        textAlign: sCell ? 'center' : 'flex-start',
                        lineHeight: 1.4
                    }}>
                        {parrafo}
                    </Typography>
                </Grid2>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 6, md: 5}} sx={{mt: 6}}>
                <img
                    src={imagen} width={'100%'} height={'auto'}
                    style={{borderRadius: 30}}
                />
            </Grid2>

            <Grid2 container
                   size={12}
                   sx={{justifyContent: sCell ? 'center' : 'flex-start' }}>

                <Grid2 container
                       size={{xs: 2, sm: 1}}
                       sx={{pr: 20, pt: masSM ? 0 : 8, borderBottom: `6px solid ${theme.palette.primary.main}`}}>
                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Tarjeta_Mision_Vision_Informacion